import { Moon, Sun } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useTheme } from '@/hooks/useTheme';

export function ThemeToggle() {
  const { theme, toggle } = useTheme();
  const isDark = theme === 'dark';
  const label = isDark ? 'Trocar para tema claro' : 'Trocar para tema escuro';

  return (
    <Button
      variant="outline"
      size="icon"
      onClick={toggle}
      aria-label={label}
      title={label}
      className="rounded-full backdrop-blur"
    >
      {isDark ? <Sun className="h-4 w-4" /> : <Moon className="h-4 w-4" />}
    </Button>
  );
}
